import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import { FilterModal, DatePicker, SelectSearch } from 'components';
import { DateConvert } from 'utilities';
import Axios from 'axios';
import { SuratPerjanjianKerjaApi } from 'api';

const ModalFilter = ({ show, setShow, data, setData }) => {
  // STATE DATA
  const [dataCustomer, setDataCustomer] = useState([
    { label: 'Semua', value: undefined },
  ]);
  const [dataProyek, setDataProyek] = useState([
    { label: 'Semua', value: undefined },
  ]);
  const [loading, setLoading] = useState(true);
  // REQUSET DATA SERVER
  const getDataDropdown = () => {
    Axios.all([
      SuratPerjanjianKerjaApi.getDropdownCustomer(),
      SuratPerjanjianKerjaApi.getDropdownProyek(),
    ])
      .then(
        Axios.spread((customer, proyek) => {
          const mapDataCustomer = customer?.data?.data
            ? customer.data.data.map((val) => ({
                label: val?.nama_customer,
                value: val?.id_customer,
              }))
            : [];
          const mapDataProyek = proyek?.data?.data
            ? proyek.data.data.map((val) => ({
                label: val?.nama_proyek,
                value: val?.id_proyek,
              }))
            : [];

          setDataCustomer([...dataCustomer, ...mapDataCustomer]);
          setDataProyek([...dataProyek, ...mapDataProyek]);
        })
      )
      .finally(() => setLoading(false));
  };
  // USE EFFECT ALL DROPDOWN
  useEffect(() => {
    getDataDropdown();
  }, []);
  // FORM VALUES
  const formInitialValues = {
    tgl_penawaran_mulai: data?.filter?.tgl_penawaran_mulai,
    tgl_penawaran_selesai: data?.filter?.tgl_penawaran_selesai,
    customer: data?.filter?.customer,
    proyek: data?.filter?.proyek,
    realisasi_penawaran_mulai: data?.filter?.realisasi_penawaran_mulai,
    realisasi_penawaran_selesai: data?.filter?.realisasi_penawaran_selesai,
  };
  const formSubmitHandler = (values) => {
    const checkActive =
      !!Object.values(values).filter((val) => val !== undefined).length > 0;

    if (checkActive) {
      setData({
        filter: {
          ...values,
          active: true,
        },
        pagination: {
          ...data.pagination,
          page: 1,
        },
      });
    } else {
      setData({
        ...data,
        filter: {
          ...values,
          active: false,
        },
      });
    }

    setShow(false);
  };
  // HANDLE CHANGE
  const onTanggalPenawaranChange = (dates, values, setValues) => {
    const [start, end] = dates;
    const startDate = start ? DateConvert(start).default : null;
    const endDate = end ? DateConvert(end).default : null;

    setValues({
      ...values,
      tgl_penawaran_mulai: startDate,
      tgl_penawaran_selesai: endDate,
    });
  };
  const onTanggalRealisasiPenawaranChange = (dates, values, setValues) => {
    const [start, end] = dates;
    const startDate = start ? DateConvert(start).default : null;
    const endDate = end ? DateConvert(end).default : null;

    setValues({
      ...values,
      realisasi_penawaran_mulai: startDate,
      realisasi_penawaran_selesai: endDate,
    });
  };
  const onResetButtonClick = (values, setValues) => {
    setValues({
      tgl_penawaran_mulai: undefined,
      tgl_penawaran_selesai: undefined,
      customer: undefined,
      proyek: undefined,
      realisasi_penawaran_mulai: undefined,
      realisasi_penawaran_selesai: undefined,
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={formInitialValues}
      onSubmit={formSubmitHandler}
    >
      {({ values, handleSubmit, setFieldValue, setValues }) => (
        <FilterModal
          show={show}
          setShow={setShow}
          onResetButtonClick={() => onResetButtonClick(values, setValues)}
          onFilterButtonClick={handleSubmit}
        >
          <DatePicker
            selectsRange
            label="Tgl. Penawaran"
            placeholderText="Pilih Tanggal Penawaran"
            startDate={
              values.tgl_penawaran_mulai
                ? new Date(values.tgl_penawaran_mulai)
                : ''
            }
            endDate={
              values.tgl_penawaran_selesai
                ? new Date(values.tgl_penawaran_selesai)
                : ''
            }
            onChange={(dates) =>
              onTanggalPenawaranChange(dates, values, setValues)
            }
            monthsShown={2}
          />
          <SelectSearch
            key={values.customer}
            label="Customer"
            placeholder="Pilih customer"
            defaultValue={dataCustomer.find(
              (val) => val.value === values.customer
            )}
            option={dataCustomer}
            onChange={(val) => setFieldValue('customer', val.value)}
            loading={loading}
          />
          <SelectSearch
            key={values.proyek}
            label="Proyek"
            placeholder="Pilih Proyek"
            defaultValue={dataProyek.find((val) => val.value === values.proyek)}
            option={dataProyek}
            onChange={(val) => setFieldValue('proyek', val.value)}
            loading={loading}
          />
          <DatePicker
            selectsRange
            label="Tgl. Realisasi Penawaran"
            placeholderText="Pilih Tanggal Realisasi Penawaran"
            startDate={
              values.realisasi_penawaran_mulai
                ? new Date(values.realisasi_penawaran_mulai)
                : ''
            }
            endDate={
              values.realisasi_penawaran_selesai
                ? new Date(values.realisasi_penawaran_selesai)
                : ''
            }
            onChange={(dates) =>
              onTanggalRealisasiPenawaranChange(dates, values, setValues)
            }
            monthsShown={2}
          />
        </FilterModal>
      )}
    </Formik>
  );
};
export default ModalFilter;
